var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyProductsIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 7.38205L12.0572 2.91064L3 6.30709V17.6181L11.9717 22.104L21 18.1541V7.38205ZM11 11.6181L5 8.61812V16.3821L11 19.3821V11.6181ZM19 16.8461L13 19.4711V11.6931L14.9999 10.9431V13.0001L16.9999 12.5001V10.1931L19 9.44309V16.8461ZM16.0718 8.40517L17.5017 7.86896L11.9428 5.08953L10.7169 5.54924L16.0718 8.40517ZM8.22152 6.48502L6.49833 7.13122L12.0572 9.91064L13.5764 9.34095L8.22152 6.48502Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.00075,
    height: 22.4861,
    transform: "matrix(-0.752448 -0.658651 -0.658651 0.752448 20.2611 5.6438)",
    fill: "currentColor",
    className: "text-black-0 dark:text-black-85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 21.6539,
    transform: "matrix(-0.752448 -0.658651 -0.658651 0.752448 18.7672 4.31738)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProductsIcn);
export default __webpack_public_path__ + "static/media/empty-products-icn.d67fd166b3ef5430817303f13810063f.svg";
export { ForwardRef as ReactComponent };